<template>
  <div class="static-text">
    <container>
      <h1>Impressum</h1>
      <p class="lead wrap">{{ content.address }}</p>
      <p class="wrap"><strong>Vertreten durch:</strong><br>{{ content.represent }}</p>
      <p class="wrap"><strong>Bildquellen</strong><br>{{ content.sources }}</p>
    </container>
  </div>
</template>

<script>
  import {api} from '@/main.js'
  import Container from "@/components/container/index";
  export default {
    name: 'Document',
    components: {Container},
    data () {
      return {
        content: false
      }
    },
    mounted () {
      api.singleton.get('imprint').then(response => {
        this.content = JSON.parse(response.data)
      })
    }
  }
</script>

<style lang="scss">
  .static-text {
    padding: 4rem;

    h1 {
      border-bottom: 1px solid $text-muted;
      margin: 0 0 3rem;
    }

    .lead {
      font-size: $size_text-big;
    }

    .wrap {
      white-space: pre-wrap;
      word-wrap: break-word;
    }

    @media (max-width: 777px) {
      padding: .75rem;
    }

    width: 100%;
    overflow-x: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/views/documents/imprint.vue